import React from 'react'
import { Typography, makeStyles, useObservable } from '@cicero/ui'
import { AttributeSchema, PageDoc, PageSchema, PageTemplateSchema, useModel } from 'models'
import { AttributeTable, PageQuickCreateForm, TemplateChooser } from 'forms'
import { PageLink, PageLinkRenderer } from '../../views/PageLink'
import { PageShareButton } from './PageShareButton'
import { PageDebugButton } from './PageDebugger'
import { PageEventSchema } from 'models/PageEventSchema'

export const PageDetails = ({ page }: { page: PageDoc }) => {
  const { wrapper } = styles()
  const Pages = useModel(PageSchema)
  const PageEvents = useModel(PageEventSchema)
  const Attributes = useModel(AttributeSchema)
  const pageList = useObservable(() => Pages.QUERY$({ selector: { parent_id: page.id } }), [], [page])
  const events = useObservable(() => PageEvents.QUERY$({ selector: { page_id: page.id } }), [], [page])
  const attributes = useObservable(() => Attributes.QUERY$(), [], [])

  const setTemplate = async (template: PageTemplateSchema) => {
    page.atomicSet('template_id', template.id)
  }

  return <div className={wrapper}>
    <Typography variant="h6">Template</Typography>
    { page.template_id ? page.template_id : <TemplateChooser name="template_choice" onChange={async ev => setTemplate(ev.target.value)} /> }
    <br /><br />

    <Typography variant="h6">Attributes</Typography>
    <AttributeTable attributes={attributes} page={page} editable />
    <br /><br />

    <Typography variant="h6">Children</Typography>
    Parent: <PageLinkRenderer id={page.parent_id}/>
    <ul>
      { pageList.map(p => <li key={p.id}><PageLink page={p} /></li>) }
    </ul>
    <PageQuickCreateForm parent_id={page.id} />
    <br /><br />

    <Typography variant="h6">Sharing</Typography>
    <PageShareButton page={page} />
    <br /><br />

    <Typography variant="h6">Debug</Typography>
    <PageDebugButton page={page} />
    <br /><br />

    <Typography variant="h6">Automations</Typography>
    <br /><br />

    <Typography variant="h6">History</Typography>
    <ul>
      { events.map((ev, i) => <li key={i}>{ ev.user_id } did { ev.type }</li>) }
    </ul>
    <br /><br />
  </div>
}

const styles = makeStyles({
  wrapper: {
    minWidth: 420,
    padding: 12,
  },
})
